import { type ComponentProps, memo } from 'react';

import { RarityCard } from '@/shared/components/ui/rarityCard';
import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardContainerProps extends ComponentProps<'div'> {}

export const ProfileOverviewCardContainer = memo(
  ({ className, children, ...props }: ProfileOverviewCardContainerProps) => {
    return (
      <RarityCard.Inner
        className={cn(
          'relative grid h-full w-full grid-cols-1 grid-rows-[1fr_auto] gap-2 p-3',
          className,
        )}
        {...props}
      >
        {children}
      </RarityCard.Inner>
    );
  },
);
